'use client';

import { WishlistProductButton } from '@veranda/shared/wishlist/client';

interface WishlistButtonProps {
  productGid: string;
  variantGid: string;
  className?: string;
}

/**
 * TileCloud-specific wishlist button component.
 * Uses the shared WishlistProductButton with "all-items" strategy.
 */
export function WishlistButton({
  productGid,
  variantGid,
  className,
}: WishlistButtonProps) {
  return (
    <WishlistProductButton
      productGid={productGid}
      variantGid={variantGid}
      className={className}
      addStrategy="all-items"
    />
  );
}
